export default __webpack_public_path__ + "1eca272a15ad82c08a71357bb4a23a8d.svg";